import { createReducer } from '@reduxjs/toolkit';
import { ILegalEntityDTO, IPersonDto } from '@qwealth/qdata';
import { setClientTaxForms, setClientTaxFormSendReceiveDates, setProfileSelectedClient, setSelectedClientTaxForm } from 'data/actions/profiles';
import { DocusignTaxQuestionnaire } from 'data/models/DocusignTaxQuestionnaire';

interface TaxProfile {
  taxYear: number;
  lastQuestionnaireSentDate: string;
  lastQuestionnaireReceivedDate: string;
  clientForms: DocusignTaxQuestionnaire[];
  selectedClientForm?: DocusignTaxQuestionnaire;
}

export interface State {
  taxProfile: TaxProfile;
  selectedClient: IPersonDto | ILegalEntityDTO | undefined;
}

const initialTaxProfile: TaxProfile = {
  taxYear: 2025,
  lastQuestionnaireReceivedDate: '-',
  lastQuestionnaireSentDate: '-',
  clientForms: [],
  selectedClientForm: undefined,
};

export const initialState: State = {
  selectedClient: undefined,
  taxProfile: initialTaxProfile,
};

export default createReducer(initialState, builder => {
  builder.addCase(setProfileSelectedClient, (state, action) => {
    state.selectedClient = action.payload;
    state.taxProfile = initialTaxProfile;
  });

  builder.addCase(setClientTaxForms, (state, action) => {
    state.taxProfile.clientForms = action.payload;
    state.taxProfile.selectedClientForm = action.payload.length > 0 ? action.payload[0] : undefined;
  });

  builder.addCase(setSelectedClientTaxForm, (state, action) => {
    state.taxProfile.selectedClientForm = action.payload;
  });

  builder.addCase(setClientTaxFormSendReceiveDates, (state, action) => {
    state.taxProfile.lastQuestionnaireReceivedDate = action.payload.taxQuestionnaireReceiveDate;
    state.taxProfile.lastQuestionnaireSentDate = action.payload.taxQuestionnaireSendDate;
  });
});
